/**
 * Safely unwrap a response's data payload when present.
 * Many generated adapter functions return an object with a `data` property
 * wrapping the actual model. This helper returns the wrapped value or
 * undefined when missing.
 */
export function unwrapData<T>(res: unknown): T | undefined {
  if (!res) return undefined;
  if (
    typeof res === 'object' &&
    res !== null &&
    'data' in (res as Record<string, unknown>)
  ) {
    return (res as { data?: unknown }).data as T | undefined;
  }
  return res as T | undefined;
}
